import {NgModule} from '@angular/core';
import {PagesSharedModule} from '../../../pages/pages-shared.module';
import {SpecialOptionsComponent} from './special-options.component';
import {RouterModule} from '@angular/router';


@NgModule({
    imports: [
        PagesSharedModule,
        RouterModule
    ],
    declarations: [
        SpecialOptionsComponent
    ],
    entryComponents: [
        SpecialOptionsComponent
    ],
    exports: [
        SpecialOptionsComponent
    ]
})
export class SpecialOptionsModule {
}
